export enum CellType {
  EMPTY = 0,
  WALL = 1,
  START = 2,
  GOAL = 3
}

export enum CellState {
  UNVISITED = 0,
  OPEN = 1,
  CLOSED = 2,
  PATH = 3
}

export class Cell {
  public readonly row: number;
  public readonly col: number;
  public type: CellType;
  public state: CellState;
  public weight: number;

  public gCost: number = Infinity;
  public hCost: number = 0;
  public fCost: number = Infinity;
  public parent: Cell | null = null;

  constructor(row: number, col: number, type: CellType = CellType.EMPTY, weight: number = 1) {
    this.row = row;
    this.col = col;
    this.type = type;
    this.state = CellState.UNVISITED;
    this.weight = weight;
  }

  get isWalkable(): boolean {
    return this.type !== CellType.WALL;
  }

  get isStart(): boolean {
    return this.type === CellType.START;
  }

  get isGoal(): boolean {
    return this.type === CellType.GOAL;
  }

  reset(): void {
    this.state = CellState.UNVISITED;
    this.gCost = Infinity;
    this.hCost = 0;
    this.fCost = Infinity;
    this.parent = null;
  }

  equals(other: Cell): boolean {
    return this.row === other.row && this.col === other.col;
  }

  toString(): string {
    return `Cell(${this.row}, ${this.col})`;
  }
}
